<template>
  <div
    :style="buttonWrapperStyle"
  >
    <a
      v-if="isLink"
      :href="link"
      class="tw-border-darkblue btn tw-cursor-pointer tw-text-black"
      :class="{
        [`btn--${this.size}`]: true
      }"
    >
      {{ label }}
    </a>
    <button
      v-else
      :id="id"
      type="button"
      :class="[classes, 'tw-cursor-pointer']"
      @click="onClick"
      :style="style"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
import './button.scss';

export default {
  name: 'my-button',

  props: {
    align: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    primary: {
      type: Boolean,
      default: false,
      required: false
    },
    isLink: {
      type: Boolean,
      default: false,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: function (value) {
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
      required: false
    },
    square: {
      type: Boolean,
      default: false,
      required: false
    },
  },

  computed: {
    classes() {
      return {
        'btn': true,
        'btn--primary': this.primary,
        'btn--secondary': !this.primary,
        'btn--square': this.square,
        [`btn--${this.size}`]: true,
      };
    },
    style() {
      return {};
    },
    buttonWrapperStyle() {
      return {
        width: this.align ? "100%" : "auto",
        textAlign: this.align || 'left'
      };
    },
  },

  methods: {
    onClick() {
      this.$emit('onClick');
    },
  },
};
</script>
